// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__1WjEo","wrapper":"header_wrapper__USq4J","link":"header_link__3tf62"};